import type { Animal } from './animal.interface';

export interface cv_PhysicalMarkerType {
    Abbreviation: string;
    Animal: Animal[];
    C_PhysicalMarkerType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsReadOnly: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    PhysicalMarkerType: string;
    SortOrder: number | null;
    Vendor: string;
    Version: number;
}
